import { render } from "./ImageViewerMobile.vue?vue&type=template&id=5bb3a196&scoped=true&ts=true"
import script from "./ImageViewerMobile.vue?vue&type=script&lang=ts"
export * from "./ImageViewerMobile.vue?vue&type=script&lang=ts"

import "./ImageViewerMobile.vue?vue&type=style&index=0&id=5bb3a196&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb3a196"]])

export default __exports__